import './NavCollapsible.scss';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import MobileMenuController from 'components/nav/shared/MobileMenuController';

class NavCollapsible extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    isNavMenuOpen: PropTypes.bool.isRequired,
    menus: PropTypes.object.isRequired,
    menuProps: PropTypes.object,
  };

  static contextTypes = {
    handleNavMenuChange: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { handleNavMenuChange } = this.context;
    $(ReactDOM.findDOMNode(this.refs.navCollapse)).on('show.bs.collapse', handleNavMenuChange);
    $(ReactDOM.findDOMNode(this.refs.navCollapse)).on('hide.bs.collapse', handleNavMenuChange);
  }

  componentWillUnmount() {
    const { handleNavMenuChange } = this.context;
    $(ReactDOM.findDOMNode(this.refs.navCollapse)).off('shown.bs.collapse', handleNavMenuChange);
    $(ReactDOM.findDOMNode(this.refs.navCollapse)).off('hide.bs.collapse', handleNavMenuChange);
  }

  render() {
    const {
      className,
      isNavMenuOpen,
      menus,
      menuProps,
    } = this.props;
    return (
      <div className={`collapse navbar-collapse ${className}`} ref="navCollapse">
        <MobileMenuController menus={menus} menuProps={menuProps} resetState={!isNavMenuOpen} />
      </div>
    );
  }
}

export default NavCollapsible;
